/*
 * Copyright 2019 Teralytics
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */
export function isCluster(c) {
    var children = c.children;
    return children && children.length > 0;
}
export function isAggregateFlow(flow) {
    var _a = flow, origin = _a.origin, dest = _a.dest, count = _a.count, aggregate = _a.aggregate;
    return origin !== undefined && dest !== undefined && count !== undefined && (aggregate ? true : false);
}
//# sourceMappingURL=types.js.map